import {SvgIconType} from 'common/components/svg-icon';
import {MetricType} from 'common/types/reports/bookmark';
import {SPECIAL_ALL_EVENT_VALUES} from 'common/report/constants';

import {Entry, isCohortEntry, isEventEntry, isFormulaEntry, isMetricEntry, isUserBasedEntry} from '../types';

export const ICON_MAPPING: Record<MetricType, SvgIconType> = {
  [MetricType.Verified]: `verified-outlined`,
  [MetricType.Simple]: `insights-tab`,
  [MetricType.Event]: `event`,
  [MetricType.Cohort]: `community`,
  [MetricType.CustomEvent]: `custom-event-beta`,
  [MetricType.Formula]: `formula`,
  [MetricType.SavedMetric]: `data-metric`, // Fallback if we don't have a specific icon for the behavior type.
  [MetricType.Funnel]: `funnels-tab`,
  [MetricType.People]: `profile`,
  [MetricType.Retention]: `retention-tab`,
  [MetricType.RetentionFrequency]: `brand-retention`,
};

export function getIconForEntry(entry: Entry): SvgIconType | null {
  if (isMetricEntry(entry)) {
    return ICON_MAPPING[entry.behavior.type];
  }
  if (isCohortEntry(entry)) {
    return `community`;
  }
  if (isFormulaEntry(entry)) {
    return `formula`;
  }
  if (isEventEntry(entry)) {
    if (
      entry.event?.custom ||
      [`$session_start`, `$session_end`].includes(entry.event?.value || entry.event?.name) ||
      SPECIAL_ALL_EVENT_VALUES.includes(entry.event?.value || entry.event?.name)
    ) {
      return `custom-event-beta`;
    } else if (entry.event) {
      return `event`;
    }
  }
  if (isUserBasedEntry(entry)) {
    return `profile`;
  }
  return null;
}
